export default {
  conference: [
    {
      // 第一个数据格式与其他数据格式不同
      // 1.1 图片为大图
      // 'videoUrl': 'http://static.geekbang.org/qconsh2017/qconsh2017-video.mp4',
      urllink: 'https://qcon.infoq.cn/2021/beijing/?utm_source=geekbang&utm_medium=banner',
      pc_imgUrl: 'https://static001.geekbang.org/resource/image/da/70/da5734a066981bf61e48b647dcffcc70.jpg',
      m_imgUrl: 'https://static001.geekbang.org/resource/image/9f/e9/9f5bef839815d349d944e51096251be9.jpg',
      title: 'QCon 全球软件开发大会',
      dateAndLoc: '2021-04-22 / 中国 / 北京'
    },
    {
      urllink: 'https://qcon.infoq.cn/2020/shanghai/?utm_source=geekbang&utm_medium=banner',
      imgUrl: 'https://static001.geekbang.org/resource/image/2f/d3/2fb46a12ab90e273c2be0f3a50406dd3.jpg',
      title: 'QCon 全球软件开发大会',
      dateAndLoc: '2020-12-20 / 中国 / 上海'
    },
    {
      urllink: 'https://qcon.infoq.cn/2020/beijing/?utm_source=geekbang&utm_medium=banner',
      imgUrl: 'https://static001.geekbang.org/resource/image/d4/72/d41a6721c43877749b26dd33ab041f72.jpg',
      title: 'QCon 全球软件开发大会',
      dateAndLoc: '2021-01-08 / 中国 / 北京'
    },
    {
      urllink: 'https://archsummit.infoq.cn/2020/shenzhen/?utm_source=geekbang&utm_medium=banner',
      imgUrl: 'https://static001.geekbang.org/resource/image/32/8e/32fb8f7851674d2cc90360c37b6aa18e.jpg',
      title: 'ArchSummit 全球架构师峰会',
      dateAndLoc: '2020-09-11 / 中国 / 深圳'
    },
    {
      urllink: 'https://aicon.infoq.cn/2020/shanghai/?utm_source=geekbang&utm_medium=banner',
      imgUrl: 'https://static001.geekbang.org/resource/image/cc/f6/ccece9147ef66cebe39eb037cfff7af6.jpg',
      title: 'AICon 全球人工智能与机器学习技术大会',
      dateAndLoc: '2020-09-24 / 中国 / 上海'
    },
    // {
    //   // 'urllink': 'https://bccon.infoq.cn/2020/beijing/?utm_source=geekbang&utm_medium=banner',
    //   'urllink': 'JavaScript:void(0)',
    //   'imgUrl': 'https://static001.geekbang.org/resource/image/0f/a6/0fb173a3c3c8232cc88b5aeb222f42a6.jpg',
    //   'title': 'BCCon 全球区块链生态技术大会',
    //   'dateAndLoc': '2020-08-14 / 中国 / 杭州'
    // },
    {
      urllink: 'https://archsummit.infoq.cn/2020/beijing/?utm_source=geekbang&utm_medium=banner',
      imgUrl: 'https://static001.geekbang.org/resource/image/32/8e/32fb8f7851674d2cc90360c37b6aa18e.jpg',
      title: 'ArchSummit 全球架构师峰会',
      dateAndLoc: '2020-12-04 / 中国 / 北京'
    },
    {
      urllink: 'https://con.infoq.cn/archives/?conf=all',
      imgUrl: 'https://static001.geekbang.org/resource/image/30/60/304bb32d40590c0edf1c6525d78f9c60.jpg',
      title: '2020 技术会议推荐',
      dateAndLoc: '北京 / 上海 / 深圳 / 广州'
    },
    {
      urllink: 'https://gmtc.geekbang.org/?utm_source=geekbang&utm_medium=banner',
      imgUrl: require('../../static/img/conference/GMTC-new.jpg'),
      title: 'GMTC 全球大前端技术大会',
      dateAndLoc: '2019-11-24 / 中国 / 深圳'
    },
    // {
    //   'urllink': 'http://bccon.geekbang.org/?utm_source=geekbang&utm_medium=banner',
    //   'imgUrl': require('../../static/img/conference/BCCon.jpg'),
    //   'title': 'BCCon 全球区块链生态技术大会',
    //   'dateAndLoc': '2018-8-18 / 中国 / 北京'
    // },
    {
      urllink: 'http://www.cnutcon.com/?utm_source=geekbang&utm_campaign=8&utm_medium=banner',
      imgUrl: require('../../static/img/conference/CNUTCon.jpg'),
      title: 'CNUTCon 全球运维技术大会',
      dateAndLoc: '2018-11-16 / 中国 / 上海'
    },
    {
      urllink: 'https://aicon.geekbang.org/',
      imgUrl: 'https://static001.geekbang.org/static/www/img/m_conference.c7604f8.jpg',
      title: 'AICon 全球人工智能与机器学习技术大会',
      dateAndLoc: '2018-09-24 / 中国 / 北京'
    },
    {
      urllink: 'http://gplus.geekbang.org/',
      imgUrl: require('../../static/img/conference/G＋.jpg'),
      title: 'G+ 全球技术价值峰会',
      dateAndLoc: '2017-04-19 / 中国 / 北京'
    },
    {
      urllink: 'http://www.chinatechday.com/2017eur',
      imgUrl: require('../../static/img/conference/CTD.jpg'),
      title: '中国技术开放日',
      dateAndLoc: '2018-06-08 / 欧洲'
    }
  ]
}
